import { ToggleOptionWithPeriod } from '@types';

// values should match "categorynamestd" prop values in gql
export const enum IndexesAllocation {
  US_LARGE_CAP_EQUITY = 'US Large Cap Equity',
  US_TREASURY_10_YEAR = '10 Year US Treasury',
  US_TREASURY_10_YEAR_FUTURES = '10 Year US Treasury Futures',
  US_TREASURY_5_YEAR = '5 Year US Treasury',
  US_TREASURY_5_YEAR_FUTURES = '5 Year US Treasury Futures',
  US_TREASURY_7_10_YEAR = '7-10 Year US Treasury',
  ALTERNATIVES = 'Alternatives',
  GLOBAL_EQUITY = 'Global Equity',
  GLOBAL_FIXED_INCOME = 'Global Fixed Income',
  HIGH_DIVIDEND = 'High Dividend Equity',
  LOW_VOLATILITY = 'Low Volatility Equity',
  CASH = 'Cash',
  CASH_NEGATIVE = 'Cash Negative', // fake allocation to handle negative cash
}

// defines order allocations series should be displayed in chart + legend
export const INDEXES_ALLOCATIONS_ORDER: IndexesAllocation[] = [
  IndexesAllocation.US_LARGE_CAP_EQUITY,
  IndexesAllocation.GLOBAL_EQUITY,
  IndexesAllocation.GLOBAL_FIXED_INCOME,
  IndexesAllocation.ALTERNATIVES,
  IndexesAllocation.HIGH_DIVIDEND,
  IndexesAllocation.US_TREASURY_7_10_YEAR,
  IndexesAllocation.US_TREASURY_10_YEAR,
  IndexesAllocation.US_TREASURY_10_YEAR_FUTURES,
  IndexesAllocation.LOW_VOLATILITY,
  IndexesAllocation.US_TREASURY_5_YEAR,
  IndexesAllocation.US_TREASURY_5_YEAR_FUTURES,
  IndexesAllocation.CASH,
  IndexesAllocation.CASH_NEGATIVE,
];

export const INDEXES_ALLOCATIONS_DATE_RANGES: Map<
  string,
  ToggleOptionWithPeriod
> = new Map([
  [
    'THREE_MONTHS',
    {
      active: false,
      value: 'THREE_MONTHS',
      text: 'products.us-index-allocations-toggle-3-month',
      period: {
        key: 'months',
        value: 3,
      },
    },
  ],
  [
    'SIX_MONTHS',
    {
      active: false,
      value: 'SIX_MONTHS',
      text: 'products.us-index-allocations-toggle-6-month',
      period: {
        key: 'months',
        value: 6,
      },
    },
  ],
  [
    'YTD',
    {
      active: false,
      value: 'YTD',
      text: 'products.us-index-allocations-toggle-ytd',
    },
  ],
  [
    'ONE_YEAR',
    {
      active: false,
      value: 'ONE_YEAR',
      text: 'products.us-index-allocations-toggle-1-year',
      period: {
        key: 'years',
        value: 1,
      },
    },
  ],
  [
    'THREE_YEARS',
    {
      active: false,
      value: 'THREE_YEARS',
      text: 'products.us-index-allocations-toggle-3-years',
      period: {
        key: 'years',
        value: 3,
      },
    },
  ],
  [
    'FIVE_YEARS',
    {
      active: false,
      value: 'FIVE_YEARS',
      text: 'products.us-index-allocations-toggle-5-years',
      period: {
        key: 'years',
        value: 5,
      },
    },
  ],
]);
